import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { DollarSign } from 'lucide-react';

const SkimCard = ({ skimData, lifetimeSkim }) => {
  return (
    <Card className="matrix-card rounded-none" data-testid="skim-card">
      <CardHeader className="border-b border-[#003B00] p-3">
        <CardTitle className="text-sm uppercase tracking-widest flex items-center gap-2">
          <DollarSign className="h-4 w-4" strokeWidth={1.5} />
          THE SKIM
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4">
        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <div className="text-[#008F11] text-xs uppercase mb-1">SESSION PROFIT</div>
            <div className={`text-lg font-bold ${(skimData?.session_profit || 0) >= 0 ? 'text-[#00FF41]' : 'text-red-500'}`}>
              {(skimData?.session_profit || 0) >= 0 ? '+' : ''}${(skimData?.session_profit || 0).toFixed(2)}
            </div>
            <div className="text-[#008F11] text-xs mt-1">
              Next skim @ ${skimData?.next_skim_at || 500}
            </div>
          </div>
          <div>
            <div className="text-[#008F11] text-xs uppercase mb-1">SESSION SKIM</div>
            <div className="text-lg font-bold text-yellow-500">
              ${(skimData?.session_skim || 0).toFixed(2)}
            </div>
            <div className="text-[#008F11] text-xs mt-1">
              ${skimData?.skim_transfer_amount || 5} per ${skimData?.skim_trigger_amount || 500} profit
            </div>
          </div>
          <div>
            <div className="text-[#008F11] text-xs uppercase mb-1">LIFETIME SKIM</div>
            <div className="text-lg font-bold text-[#00FF41]">
              ${lifetimeSkim.toFixed(2)}
            </div>
            <div className="text-[#008F11] text-xs mt-1">
              Total transferred
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SkimCard;
